import { useParams } from 'react-router-dom';

import { MilesTable } from 'components';

import { useGetRequest } from 'hooks';

import { AuditTrailDashboard, AuditTrailResponse } from 'codegen';

import { columns } from './lib';

export const AuditTrail = () => {
  const { snapId } = useParams();

  const { loading, data } = useGetRequest<AuditTrailDashboard>({
    url: '/audit',
    queryParams: { entityType: AuditTrailResponse.entityType.SNAP, entityId: snapId },
    options: {
      refreshDeps: [snapId],
    },
  });

  return (
    <MilesTable
      rowKey='id'
      loading={loading}
      columns={columns}
      dataSource={data?.auditTrailList}
    />
  );
};
